/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import Avatar from 'antd/lib/avatar';
import Spin from 'antd/lib/spin';
import Dropdown from 'antd/lib/dropdown';
import notification from 'antd/lib/notification';
import Tooltip from 'antd/lib/tooltip';
import Table from 'antd/lib/table';
import Switch from 'antd/lib/switch';
import {
  getRecentIncidents,
  getAlertPreferencesList,
  updateSpecificAlertPreferences,
  updateAllAlertPreferences,
} from '../../../../API';
import { ChangeEmailModal } from './components/ChangeEmailModal';
import { ChangePhoneModal } from './components/ChangePhoneModal';
import { config } from '../../../../config';

import './AlertsPreferences.less';

// ICONS
import dropdownArrowGrey from '../../../../icons/dropdown-grey.svg';
import dropdownArrowLightGrey from '../../../../icons/dropdown-light-grey.svg';
import dropdownArrowBlue from '../../../../icons/dropdown-blue.svg';
import { CheckmarkIcon } from '../CheckmarkIcon';

// IMAGES
import alertsNotSetupLight from '../../../../images/alerts-not-setup-light.png';
import alertsNotSetupDark from '../../../../images/alerts-not-setup-dark.png';
import emailLightIcon from '../../../../images/email-light.png';
import emailDarkIcon from '../../../../images/email-dark.png';
import smsLightIcon from '../../../../images/sms-light.png';
import smsDarkIcon from '../../../../images/sms-dark.png';

const { REACT_APP_BUILD_ENV } = config;

export const AlertsPreferences = (props) => {
  const { theme, buildings } = props;
  const { building } = useParams();
  const { search } = useLocation();
  const { system, page } = queryString.parse(search);
  const history = useHistory();
  const [eventsCount] = useState(0);
  const [alertsSetup, setAlertsSetup] = useState(true);
  const [alertPreferences, setAlertPreferences] = useState([]);
  const [isEmailColumnToggled, setIsEmailColumnToggled] = useState(false);
  const [isTextColumnToggled, setIsTextColumnToggled] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('All Systems');
  const [filters, setFilters] = useState(['All Systems']);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isChangeEmailModalOpen, setIsChangeEmailModalOpen] = useState(false);
  const [isChangePhoneModalOpen, setIsChangePhoneModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const currentUser = JSON.parse(localStorage.getItem('current_user'));
  const { email, phone_number: phoneNumber } = currentUser;

  const checkColumnToggle = (key, preferences) => {
    let isToggled = true;
    if (preferences.length === 0) {
      isToggled = false;
    }

    // eslint-disable-next-line prefer-const
    for (let alert of preferences) {
      if (alert[key] === false) {
        isToggled = false;
        break;
      }
    }

    if (key === 'is_receiving_email') {
      setIsEmailColumnToggled(isToggled);
    } else {
      setIsTextColumnToggled(isToggled);
    }
  };

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const incidentsList = await getRecentIncidents(REACT_APP_BUILD_ENV, building);
      setAlertsSetup(incidentsList.alerts_setup);

      let preferencesList = await getAlertPreferencesList(REACT_APP_BUILD_ENV, building);
      const tempFilters = ['All Systems'];
      preferencesList.map((alert) => {
        if (!tempFilters.includes(alert.hvac_system_display)) {
          tempFilters.push(alert.hvac_system_display);
        }
        return tempFilters;
      });
      setFilters(tempFilters);
      if (system && system !== 'All Systems') {
        preferencesList = preferencesList.filter((alert) => alert.hvac_system_display === system);
      }
      setAlertPreferences(preferencesList);
      checkColumnToggle('is_receiving_email', preferencesList);
      checkColumnToggle('is_receiving_text', preferencesList);
      setIsLoading(false);
    }

    fetchData();
  }, [building, page]);

  useEffect(() => {
    if (buildings.length > 0) {
      const sessionSelectedBuilding = JSON.parse(sessionStorage.getItem('selectedBuilding') || '{}');

      window.document.title = `${sessionSelectedBuilding.name} | Alerts Preferences`;
    }
  }, [buildings]);

  const applyFilter = async (filter, filterType) => {
    const preferencesFilters = {};
    if (system) {
      preferencesFilters.hvac_system = system;
    }
    let filteredPreferences = await getAlertPreferencesList(REACT_APP_BUILD_ENV, building);

    if (filter !== 'All Systems' && filterType !== 'page') {
      filteredPreferences = filteredPreferences.filter((alert) => alert.hvac_system_display === filter);
    }

    if (system !== 'All Systems' && filterType === 'page') {
      filteredPreferences = filteredPreferences.filter((alert) => alert.hvac_system_display === system);
    }

    checkColumnToggle('is_receiving_email', filteredPreferences);
    checkColumnToggle('is_receiving_text', filteredPreferences);
    setAlertPreferences(filteredPreferences);
    if (filterType !== 'page') {
      setSelectedFilter(filter);
    }
    let filtersUrl = '';
    if (system && filterType !== 'system') filtersUrl += `&system=${system}`;
    switch (filterType) {
      case 'system':
        filtersUrl += `&system=${filter}`;
        break;
      case 'page':
        filtersUrl += `&page=${filter}`;
        break;
      default:
        break;
    }
    history.push(`/alerts/${building}?tab=Preferences${filtersUrl}`);
  };

  const handleEmailChange = () => setIsChangeEmailModalOpen(true);

  const handlePhoneChange = () => setIsChangePhoneModalOpen(true);

  const toggleAllAlerts = async (type, isToggled) => {
    const subscriptionType = isToggled ? 'unsubscribe' : 'subscribe';

    const response = await updateAllAlertPreferences(REACT_APP_BUILD_ENV, building, type, subscriptionType);

    if (response) {
      // handle success
      notification.info({
        className: `alerts-preferences-toggle-notification alerts-preferences-toggle-notification-${theme}`,
        placement: 'topRight',
        duration: 5,
        icon: <CheckmarkIcon theme={theme} />,
        message: 'Alert Preferences Saved',
      });
    } else {
      notification.info({
        className: `alerts-preferences-toggle-notification alerts-preferences-toggle-notification-${theme}`,
        placement: 'topRight',
        duration: 5,
        icon: <CheckmarkIcon theme={theme} />,
        message: 'Alert Preferences Could Not Be Saved',
        description: `We encountered an error while trying to save alert preferences. Please try again.`,
      });
    }

    const updatedPreferencesList = await getAlertPreferencesList(REACT_APP_BUILD_ENV, building);
    setAlertPreferences(updatedPreferencesList);

    if (type === 'email') {
      checkColumnToggle('is_receiving_email', updatedPreferencesList);
    } else {
      checkColumnToggle('is_receiving_text', updatedPreferencesList);
    }
  };

  const toggleSpecificAlert = async (type, isToggled, alertId) => {
    const subscriptionType = isToggled ? 'unsubscribe' : 'subscribe';

    const response = await updateSpecificAlertPreferences(
      REACT_APP_BUILD_ENV,
      building,
      alertId,
      type,
      subscriptionType,
    );

    if (response) {
      // handle success
      notification.info({
        className: `alerts-preferences-toggle-notification alerts-preferences-toggle-notification-${theme}`,
        placement: 'topRight',
        duration: 5,
        icon: <CheckmarkIcon theme={theme} />,
        message: 'Alert Preferences Saved',
      });
    } else {
      notification.info({
        className: `alerts-preferences-toggle-notification alerts-preferences-toggle-notification-${theme}`,
        placement: 'topRight',
        duration: 5,
        icon: <CheckmarkIcon theme={theme} />,
        message: 'Alert Preferences Could Not Be Saved',
        description: `We encountered an error while trying to save alert preferences. Please try again.`,
      });
    }

    const updatedPreferencesList = await getAlertPreferencesList(REACT_APP_BUILD_ENV, building);
    setAlertPreferences(updatedPreferencesList);

    if (type === 'email') {
      checkColumnToggle('is_receiving_email', updatedPreferencesList);
    } else {
      checkColumnToggle('is_receiving_text', updatedPreferencesList);
    }
  };

  const changeEmail = () => {
    setIsChangeEmailModalOpen(false);
    notification.info({
      className: `alerts-preferences-contacts-notification alerts-preferences-contacts-notification-${theme}`,
      placement: 'topRight',
      duration: 5,
      icon: <CheckmarkIcon theme={theme} />,
      message: 'E-mail successfully changed!',
    });
  };

  const changePhone = () => {
    setIsChangePhoneModalOpen(false);
    notification.info({
      className: `alerts-preferences-contacts-notification alerts-preferences-contacts-notification-${theme}`,
      placement: 'topRight',
      duration: 5,
      icon: <CheckmarkIcon theme={theme} />,
      message: 'Phone number successfully changed!',
    });
  };

  const columns = [
    {
      title: 'ALERTS',
      dataIndex: 'alert_friendly_name',
      className: 'alerts-preferences-table-column-name-mobile',
    },
    {
      title: (
        <div className="alerts-preferences-header-toggle">
          <Switch checked={isEmailColumnToggled} onChange={() => toggleAllAlerts('email', isEmailColumnToggled)} />
          <span>E-MAIL</span>
          {theme === 'light' ? (
            <img className="alerts-preferences-email-icon" src={emailLightIcon} alt="e-mail" />
          ) : (
            <img className="alerts-preferences-email-icon" src={emailDarkIcon} alt="e-mail" />
          )}
        </div>
      ),
      dataIndex: ['is_receiving_email', 'is_receiving_text'],
      className: 'alerts-preferences-table-column-toggle-email',
      render: (text, alert) => {
        const isToggled = alert.is_receiving_email;
        return (
          <div className="alerts-preferences-table-column-container">
            <span className="mobile">E-mail:</span>
            <Switch checked={isToggled} onChange={() => toggleSpecificAlert('email', isToggled, alert.uid_hash)} />
          </div>
        );
      },
    },
    {
      title: (
        <div className="alerts-preferences-header-toggle">
          <Switch checked={isTextColumnToggled} onChange={() => toggleAllAlerts('text', isTextColumnToggled)} />
          <span>SMS</span>
          {theme === 'light' ? (
            <img className="alerts-preferences-phone-icon" src={smsLightIcon} alt="text" />
          ) : (
            <img className="alerts-preferences-phone-icon" src={smsDarkIcon} alt="text" />
          )}
        </div>
      ),
      dataIndex: ['is_receiving_email', 'is_receiving_text'],
      className: 'alerts-preferences-table-column-toggle-sms',
      render: (text, alert) => {
        const isToggled = alert.is_receiving_text;
        return (
          <div className="alerts-preferences-table-column-container">
            <span className="mobile">SMS:</span>
            <Switch checked={isToggled} onChange={() => toggleSpecificAlert('text', isToggled, alert.uid_hash)} />
          </div>
        );
      },
    },
    {
      title: 'ALERTS',
      dataIndex: 'alert_friendly_name',
      className: 'desktop',
    },
    {
      title: 'CONDITIONS',
      dataIndex: 'conditions',
      render: (conditions) => {
        return (
          <div className="alerts-preferences-table-column-container">
            <span className="mobile">Conditions:</span>
            <div className="alerts-preferences-table-column-conditions-container">
              {conditions.map((condition) => (
                <div key={condition.data_point_tag}>
                  {`${condition.friendly_name} ${condition.comparison_operator_display} ${condition.limit} ${condition.measurement_unit_display}`}
                </div>
              ))}
            </div>
          </div>
        );
      },
    },
    {
      title: 'TIER',
      dataIndex: 'tier',
      className: 'alerts-preferences-table-column-tier',
      render: (tier) => {
        return (
          <div className="alerts-preferences-table-column-container">
            <span className="mobile">Alert Tier:</span>
            <span>{tier.charAt(0).toUpperCase() + tier.slice(1)}</span>
          </div>
        );
      },
    },
    {
      title: 'ALSO SUBSCRIBED',
      dataIndex: 'subscribers',
      className: 'alerts-preferences-table-column-subscribers',
      render: (users) => {
        if (users.length > 0) {
          return (
            <div className="alerts-preferences-table-column-subscribers-container">
              <span className="mobile">Also subscribed:</span>
              <Avatar.Group className="alerts-preferences-item-users-container">
                {users.map((user) => {
                  const colour = user.avatar_color || '#ffffff';
                  const firstAndLastNames = user.name.split(' ');
                  return (
                    <Tooltip overlayClassName={`app-tooltip-${theme}`} placement="bottom" title={user.name}>
                      <Avatar className="app-profile-icon" alt="profile icon" style={{ backgroundColor: colour }}>
                        {`${firstAndLastNames[0][0]}${firstAndLastNames[1][0]}`}
                      </Avatar>
                    </Tooltip>
                  );
                })}
              </Avatar.Group>
            </div>
          );
        }
        return <span className="alerts-preferences-item-info">Nobody else yet</span>;
      },
    },
  ];

  const getDropdownIcon = () => {
    if (isDropdownOpen) {
      return <img className="dropdown-icon" src={dropdownArrowBlue} alt="dropdown" />;
    }
    return theme === 'light' ? (
      <img className="dropdown-icon" src={dropdownArrowGrey} alt="dropdown" />
    ) : (
      <img className="dropdown-icon" src={dropdownArrowLightGrey} alt="dropdown" />
    );
  };

  const renderAlertsNotSetup = () => {
    return (
      <div className="alerts-preferences-card">
        <div className="alerts-preferences-card-header">
          <h1 className="alerts-preferences-card-title">Receive alert updates</h1>
          <div className="alerts-preferences-no-alerts">
            {theme === 'light' ? (
              <img className="alerts-not-setup-image" src={alertsNotSetupLight} alt="no-alerts" />
            ) : (
              <img className="alerts-not-setup-image" src={alertsNotSetupDark} alt="no-alerts" />
            )}
            <div className="alerts-preferences-no-alerts-heading">
              You will be able to manage your alert preferences once your building is fully set up
            </div>
            <div className="alerts-preferences-no-alerts-text">
              Get notified when there are problems with your building via e-mail and text
            </div>
          </div>
        </div>
      </div>
    );
  };

  const paginationProperties = {
    className: 'alerts-overview-table-pagination',
    hideOnSinglePage: false,
    current: page || 1,
    pageSize: 10,
    showSizeChanger: false,
    total: eventsCount,
    showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} preferences`,
    onChange: (pageNumber) => applyFilter(pageNumber, 'page'),
  };

  const filterItems = filters.map((filterItem) => {
    return {
      key: `filter-${filterItem}`,
      label: (
        <div key={filterItem} onClick={() => applyFilter(filterItem, 'system')}>
          {filterItem}
        </div>
      ),
    };
  });

  const renderAlertPreferences = () => {
    // Remove "Text" column if the user does not have a phone number
    if (!phoneNumber) columns.splice(2, 1);

    return (
      <div className="alerts-preferences-card">
        <div className="alerts-preferences-card-header">
          <h1 className="alerts-preferences-card-title">Receive alert updates</h1>
          <div className="alerts-preferences-header-container">
            <div className="alerts-preferences-select-container">
              <span className="alerts-preferences-description">
                Get notified when there are problems with your building.
              </span>
              <Dropdown
                className={`app-dropdown app-dropdown-${theme}`}
                trigger={['click']}
                onOpenChange={() => setIsDropdownOpen(!isDropdownOpen)}
                menu={{ items: filterItems }}
              >
                <div className="alerts-preferences-select">
                  {selectedFilter}
                  {getDropdownIcon()}
                </div>
              </Dropdown>
            </div>
            <div className="alerts-preferences-contacts">
              <span>Your e-mail:</span>
              <div className="alerts-preferences-contacts-container">
                <strong>{email}</strong>
                <span className="alerts-preferences-contacts-verified">(Verified)</span>
                <span
                  className="alerts-preferences-contacts-change"
                  onClick={handleEmailChange}
                  onKeyDown={handleEmailChange}
                  role="button"
                  tabIndex={-1}
                >
                  Change
                </span>
              </div>
              {phoneNumber ? (
                <>
                  <span>Your phone:</span>
                  <div className="alerts-preferences-contacts-container">
                    <strong>{phoneNumber}</strong>
                    <span className="alerts-preferences-contacts-verified">(Verified)</span>
                    <span
                      className="alerts-preferences-contacts-change"
                      onClick={handlePhoneChange}
                      onKeyDown={handlePhoneChange}
                      role="button"
                      tabIndex={-1}
                    >
                      Change
                    </span>
                  </div>
                </>
              ) : null}
            </div>
            <div className="alerts-preferences-toggle-group-mobile">
              <div className="alerts-preferences-toggle-container-mobile">
                <span>All E-mail Alerts:</span>
                <Switch
                  checked={isEmailColumnToggled}
                  onChange={() => toggleAllAlerts('email', isEmailColumnToggled)}
                />
              </div>
              {phoneNumber && (
                <div className="alerts-preferences-toggle-container-mobile">
                  <span>All Text Alerts:</span>
                  <Switch checked={isTextColumnToggled} onChange={() => toggleAllAlerts('text', isTextColumnToggled)} />
                </div>
              )}
            </div>
          </div>
        </div>
        <Table
          className="alerts-preferences-table"
          columns={columns}
          dataSource={alertPreferences}
          pagination={paginationProperties}
        />
      </div>
    );
  };

  return (
    <div className={`alerts-preferences-wrapper alerts-preferences-wrapper-${theme}`}>
      {isLoading ? (
        <div className={`alerts-overview-wrapper alerts-overview-wrapper-${theme}`}>
          <Spin />
        </div>
      ) : (
        <>{!alertsSetup && !isLoading ? renderAlertsNotSetup() : renderAlertPreferences()}</>
      )}
      {isChangeEmailModalOpen && (
        <ChangeEmailModal onCancel={() => setIsChangeEmailModalOpen(false)} onSubmit={changeEmail} theme={theme} />
      )}
      {isChangePhoneModalOpen && (
        <ChangePhoneModal onCancel={() => setIsChangePhoneModalOpen(false)} onSubmit={changePhone} theme={theme} />
      )}
    </div>
  );
};
